import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "../store";
import axios from "axios";

class AreaService{
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getAll(region) {
        return Vue.axios.get(`${API_HOST}/api/area`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                region: region ? region : null
            },
            cancelToken: this.cancelTokenSource.token,
        });
    }
}

export default new AreaService()